// extracted by mini-css-extract-plugin
module.exports = {"container":"TenantInfo_container__2NGP9","fields":"TenantInfo_fields__2LEcZ","field":"TenantInfo_field__cq1PK","label":"TenantInfo_label__2JDx3"};